import withAuth from '../WithAuth/WithAuth';
import EventTable from "./EventTable/EventTable";

const Dashboard = () => {
    return (
        <EventTable />
    );
};

export default withAuth(Dashboard);
